import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "是否異常",
    isNumber: true,
  },
];

export const BarTrack = {
  label: "四級&三級 異常追蹤諮詢狀況",
  key: "BarTrack",
  path: "HealthAnalysisManagement/BarTrack",
  api: "TCS_V_EyesS01",
  render: (options) => (
    <Diagram.HealthAnalysisManagement.BarTrack {...options} />
  ),
  // isBarStack: true,
  isYMulti: true,
  rightYDomain: [0, 120],
  xKey: "type",
  barUnit: "人",
  barColumns: [
    {
      key: "aa",
      label: "異常人數",
      ui: "bar",
    },
    {
      key: "bb",
      label: "已追蹤",
      ui: "bar",
    },
  ],
  lineUnit: "%",
  lineColumns: [
    {
      key: "cc",
      label: "跟進%",
      ui: "line",
    },
  ],
  columns: [],
};
